import React from "react"
import {GatsbyImage, StaticImage, getImage} from "gatsby-plugin-image"
import "./project-selection-section.styles.scss"
import Link from "gatsby-link"



const ProjectSelection = () => {
  return (
    <section className="flex lg:flex-row flex-col justify-evenly items-center py-24 container">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mt-24 lg:mt-0">
        <div className="judge-item">
          <StaticImage
              src="../../../assets/img/navridis_square.jpg"
              alt=""
              placeholder="blurred"
              layout="fixed"
              width={96}
              height={96}
              quality={100}
              className="rounded-full judge-img" />
        </div>
        <div className="judge-item">
          <StaticImage
              src='../../../assets/img/mavroeidi_sq.jpg'
              alt=""
              placeholder="blurred"
              layout="fixed"
              width={96}
              height={96}
              quality={100}
              className="rounded-full judge-img" />
        </div>
        <div className="judge-item">
          <StaticImage
              src="../../../assets/img/papailiakis_sq.jpg"
              alt=""
              placeholder="blurred"
              layout="fixed"
              width={96}
              height={96}
              quality={100}
              className="rounded-full judge-img" />
        </div>
        <div className="judge-item">
          <StaticImage
              src="../../../assets/img/koskina_sq.jpg"
              alt=""
              placeholder="blurred"
              layout="fixed"
              width={96}
              height={96}
              quality={100}
              className="rounded-full judge-img" />
        </div>
        <div className="judge-item">
          <StaticImage
              src="../../../assets/img/boulmetis_sq.jpg"
              alt=""
              placeholder="blurred"
              layout="fixed"
              width={96}
              height={96}
              quality={100}
              className="rounded-full judge-img" />
        </div>
        <div className="judge-item">
          <StaticImage
              src='../../../assets/img/kokkinias_sq.jpg'
              alt=""
              placeholder="blurred"
              layout="fixed"
              width={96}
              height={96}
              quality={100}
              className="rounded-full judge-img" />
        </div>
        <div className="judge-item col-span-2 sm:col-span-3 place-self-center">
          <StaticImage
              src="../../../assets/img/charalambopoulos.jpg"
              alt=""
              placeholder="blurred"
              layout="fixed"
              width={96}
              height={96}
              quality={100}
              className="rounded-full judge-img" />
        </div>
      </div>
      <div className="max-w-[450px] order-first lg:order-last">
        <h3 className="text-lg text-secondary font-bold mb-4">ΕΠΙΛΟΓΗ ΕΡΓΩΝ</h3>
        <p className="mb-4">
        Η Κριτική Επιτροπή επέλεξε τα έργα που αποτυπώνουν  αισθητικά και εννοιολογικά την ιδέα του brief. 
        </p>
        <Link className="btn-primary" to="/judges">Γνώρισε την επιτροπή</Link>
      </div>
    </section>
  )
}

export default ProjectSelection
